module.exports = __webpack_public_path__ + "img/pic_14s.ba61beca.gif";